export default function Dimensions({ title, dimensions }) {
    return (
        <table className="w-full table-auto align-top divide-y-2 divide-white devide-4 text-left">
            <thead>
                <tr>
                    <th scope="col" colSpan={dimensions.length} className="uppercase p-4 font-bold">
                        {title}
                    </th>
                </tr>
            </thead>
            <tbody className="divide-y-2 divide-white">
                {dimensions.length > 0 && (
                    <>
                        <tr>
                            {dimensions.map((d) => (
                                <td key={`title-${d.id}`} className="uppercase font-semibold py-2 px-4 h-10">
                                    {d.title}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            {dimensions.map((d) => (
                                <td key={d.id.toString()} className="py-2 px-4">
                                    {d.sizes.map((s) => (
                                        <div key={s.id} className="py-1">
                                            <span className="font-semibold">{s.Key}</span>: {s.Value}
                                            <br />
                                        </div>
                                    ))}
                                </td>
                            ))}
                        </tr>
                    </>
                )}
            </tbody>
        </table>
    );
}
